import { useTranslation } from 'react-i18next'
import { GraduationCap } from 'lucide-react'
import Button from '../ui/Button'
import { UNIVERSITY_DESTINATIONS } from '../../data/siteContent'
import { countryFlag } from '../../utils/countryFlag'

export default function UniversityDestinationsSection() {
  const { t } = useTranslation()

  return (
    <section className="my-10 space-y-10">
      <div className="text-center">
        <h3 className="text-2xl font-bold text-primary sm:text-3xl">
          {t('pagesExtras.universitiesTitle')}
        </h3>
        <p className="mx-auto mt-2 max-w-2xl text-text/65">
          {t('pagesExtras.universitiesSubtitle')}
        </p>
      </div>

      {UNIVERSITY_DESTINATIONS.map(({ regionKey, countryCode, universities }) => (
        <div key={regionKey}>
          <h4 className="mb-4 flex items-center gap-3 text-lg font-bold text-primary">
            <span
              className="flex h-10 w-10 items-center justify-center rounded-xl bg-background text-2xl shadow-sm ring-1 ring-border"
              aria-hidden
            >
              {countryFlag(countryCode)}
            </span>
            {t(`pagesExtras.regions.${regionKey}`)}
          </h4>
          <ul className="grid gap-3 sm:grid-cols-2">
            {universities.map(({ name, city }) => (
              <li
                key={name}
                className="flex items-start gap-3 rounded-xl border border-border bg-white px-4 py-3 shadow-sm shadow-primary/5 transition-shadow hover:shadow-md hover:shadow-primary/10"
              >
                <span
                  className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary/5 text-xl"
                  title={t(`pagesExtras.regions.${regionKey}`)}
                  aria-hidden
                >
                  {countryFlag(countryCode)}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="flex items-start gap-2 font-semibold leading-snug text-primary">
                    <GraduationCap className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden />
                    <span>{name}</span>
                  </p>
                  {city && <p className="mt-1 text-sm text-text/60">{city}</p>}
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}

      <div className="pt-2">
        <Button to="/counseling" variant="accent">
          {t('pagesExtras.bookCounseling')}
        </Button>
      </div>
    </section>
  )
}
